import { h as __h } from "preact";
import { Component } from "preact";

/** @import { orgResponse } from "~/backend/validate.js"; */
import { identity } from "~/lib/identity.js";
import html from "~/util/html.js";
import Icon from "~/component/Icon.js";
/** @import { TriggerProps } from "~/component/Tooltip.js"; */
import Tooltip from "~/component/Tooltip.js";
import adminStyle from "~/admin/lib/style.js";

/**
 * @extends {Component<Props>}
 *
 * @typedef {object} Props
 * @property {Pick<orgResponse, "id" | "name">} org
 */
export default class OrgChip extends Component {
  render() {
    const {
      org
    } = this.props;
    if (identity.canAccessOrg(org.id)) {
      return __h("a", {
        href: "/org/" + org.id,
        "class": adminStyle.chip
      }, this.renderContents());
    }
    return __h(Tooltip, {
      placement: "top",
      contents: "You don't have access to " + org.name + "."
    }, (/** @type {TriggerProps} */trigger) => __h("button", {
      type: "button",
      "class": adminStyle.chip,
      ...trigger,
      "aria-disabled": "true"
    }, this.renderContents()));
  }
  renderContents() {
    const {
      org
    } = this.props;
    return [__h(Icon, {
      name: "office",
      size: 12
    }), __h("span", {}, org.name)];
  }
}